import { render } from "./tuserLog.vue?vue&type=template&id=36242f96&scoped=true"
import script from "./tuserLog.vue?vue&type=script&lang=js"
export * from "./tuserLog.vue?vue&type=script&lang=js"

import "./tuserLog.vue?vue&type=style&index=0&id=36242f96&scoped=true&lang=css"

import exportComponent from "D:\\zhang\\项目\\经皮黄疸仪\\jaundiceweb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36242f96"]])

export default __exports__